import { readonly, ref } from 'vue';
import { isYourLimit } from '../limits.ts';

export interface Notice {
  id: number;
  tone: 'info' | 'error' | 'success';
  text: string;
  /** Somewhere to go about it (e.g. Your plan, for a plan limit). */
  link: { label: string; routeName: string } | null;
}

const notices = ref<Notice[]>([]);
let seq = 0;

/** App-wide transient messages ("Updated 8 · 2 couldn't be changed"). */
export function useNotice() {
  function show(
    text: string,
    tone: Notice['tone'] = 'info',
    ms = 5000,
    link: Notice['link'] = null,
  ): void {
    seq += 1;
    const notice = { id: seq, tone, text, link };
    notices.value = [...notices.value.slice(-2), notice];
    setTimeout(() => dismiss(notice.id), ms);
  }
  function dismiss(id: number): void {
    notices.value = notices.value.filter((n) => n.id !== id);
  }
  /**
   * A failed action: the server's message (or `fallback`), after `about` (e.g. a
   * file's name) when given; at a limit of your own plan, linking to Your plan.
   */
  function fail(err: unknown, fallback: string, about: string | null): void {
    const message = (err instanceof Error && err.message) || fallback;
    const text = about ? `${about}: ${message}` : message;
    if (isYourLimit(err)) show(text, 'error', 10000, { label: 'See your plan', routeName: 'plan' });
    else show(text, 'error', 8000);
  }
  return { notices: readonly(notices), show, dismiss, fail };
}
